import { createSlice } from "@reduxjs/toolkit";
import { getSelectedMapViewId } from "../components/LiveLocation/LocationUtils";

const initialState = {
    stableLocationCount: 0,
    updateLatLong: [],
    isLatLongDisable: true,
    isLiveLocationMapOpen: false,
    remoteParticipantsLocationInfo: [],
    selectedParticipant: {},
    mapTypeId: getSelectedMapViewId(),
    isSaveBtnDisabled: false,
};

const liveLocationReducerSlice = createSlice({
    name: "liveLocationReducer",
    initialState,
    reducers: {
        setStableLocationCount(state, action) {
            state.stableLocationCount = action.payload;
        },
        setUpdateLatLong(state, action) {
            state.updateLatLong = action.payload;
        },
        setIsLatLongDisable(state, action) {
            state.isLatLongDisable = action.payload;
        },
        setIsLiveLocationMapOpen(state, action) {
            state.isLiveLocationMapOpen = action.payload;
        },
        setRemoteParticipantsLocationInfo(state, action) {
            state.remoteParticipantsLocationInfo = action.payload;
        },
        setSelectedParticipant(state, action) {
            state.selectedParticipant = action.payload;
        },
        setMapTypeId(state, action) {
            state.mapTypeId = action.payload;
        },
        setIsSaveBtnDisabled(state, action) {
            state.isSaveBtnDisabled = action.payload;
        },
        resetLiveLocationReducer() {
            return initialState;
        },
    },
});

export const {
    setStableLocationCount,
    setUpdateLatLong,
    setIsLatLongDisable,
    setIsLiveLocationMapOpen,
    setRemoteParticipantsLocationInfo,
    setSelectedParticipant,
    setMapTypeId,
    setIsSaveBtnDisabled,
    resetLiveLocationReducer,
} = liveLocationReducerSlice.actions;

export default liveLocationReducerSlice.reducer;
